export type BuildInfo = {
  version: string;
  commit: string;
  builtAt: string;
};

const buildInfo: BuildInfo = {
  version: import.meta.env.VITE_APP_VERSION || "dev",
  commit: import.meta.env.VITE_APP_COMMIT || "unknown",
  builtAt: import.meta.env.VITE_APP_BUILT_AT || "unknown",
};

declare global {
  interface Window {
    __APP_BUILD__?: BuildInfo;
  }
}

if (typeof window !== "undefined") {
  window.__APP_BUILD__ = buildInfo;
}

export default buildInfo;
